import { useSyncExternalStore } from "react";
import { PlanIdApi } from "@/types/PlanTypes";

/**
 * Session-scoped set of plan ids the backend refused with a 403 even though
 * the plan list reports them as active (R-1856). The two data sources can
 * disagree — e.g. a plan detached from the subscription mid plan-change is
 * still "active" in the plan list but fails PlanPermission — and the backend
 * verdict must win: a denied plan can never be a customize/upgrade target, so
 * ownership resolution has to stop offering it or the page keeps retargeting
 * the same plan and dead-ends on the pricing error banner.
 */
let deniedPlanIds: ReadonlySet<PlanIdApi> = new Set();

const listeners = new Set<() => void>();

export function markPlanBackendDenied(planId: PlanIdApi) {
  if (deniedPlanIds.has(planId)) return;
  deniedPlanIds = new Set([...deniedPlanIds, planId]);
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return deniedPlanIds;
}

export default function useBackendDeniedPlanIds(): ReadonlySet<PlanIdApi> {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
